import React from "react";
import { useDispatch, useSelector } from 'react-redux';
import { CollectSiteProductSetProduct } from '../../../server/CollectSite';
import { setUserEntry } from '../../../server/Customer';
import { ShoppingCart } from "lucide-react";

const ProductAddToCart = ({ element, haveInfo }) => {
  const dispatch = useDispatch();
  const { user, role, productsInCart, stationId } = useSelector(state => ({
    role: state.user.role,
    user: state.user.user,
    productsInCart: state.productsInCart.productsInCart,
    stationId: state.user.stationId,
  }));

  const inCart = productsInCart.find(item => item.ProductMkt === element.Mkt || item.ProductMkt === element.ProductMkt);
  
  const CollectSiteProductSetProducts = (element, quantity, stationId) => {
    if (!user || user.UserTypeId === 5) {
      dispatch(setUserEntry([true, "login"]))
    }
    else {
      const finalPrice = element.SalePrice ? parseFloat(element.SalePrice).toFixed(2) : element.Price;
      dispatch(CollectSiteProductSetProduct({ ...element, Price: finalPrice }, quantity, stationId));
    }
  }

  const WeightJump = element.WeightJump > 0 ? element.WeightJump : 1;
  
  return (
    <div className={inCart ? "add-to-cart in-cart" : "add-to-cart not-in-cart"}>
      {!role && (element.QuantityCanOrder >= WeightJump || (inCart && inCart.Quantity > 0)) ?
        <div className="wrap" onClick={!inCart ? () => CollectSiteProductSetProducts(element, 1, stationId) : null}>
          {inCart && inCart.Quantity > 0 ?
            <>
              <div className="add-btn" onClick={inCart && (!haveInfo || element.QuantityCanOrder >= WeightJump) ? () => CollectSiteProductSetProducts(element, 1, stationId) : null}>
                <p>+</p>
              </div>
              <div className="col-lg-7">
                <input readOnly
                  type="text"
                  value={inCart.Quantity}
                  disabled={true}
                />
              </div>
              <div className="minus-btn" onClick={inCart ? () => CollectSiteProductSetProducts(element, -1, stationId) : null}>
                <p>-</p>
              </div>
            </> :
            <p onClick={inCart && (!haveInfo || element.QuantityCanOrder >= WeightJump) ? () => CollectSiteProductSetProducts(element, 1, stationId) : null}>
              <ShoppingCart size={24}/>
            </p>
          }
        </div>
        : (inCart && inCart?.Quantity == 0) && (
            <div className="outOfStock">אזל מהמלאי</div>
          )
        }
    </div>
  )
}

export default ProductAddToCart;